import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

// Components
import { RequestStatus } from '@beef/smart-kit';

// Utils
import { maskPhoneNumber } from 'utils/validators';
import { templateParser } from 'utils/formatString';

// Actions
import { toggleIncomingInviteModal } from '../../store/actions';

const InvitationStatus = ({ status }) => {
  const dispatch = useDispatch();
  const { incomingInvitation } = useSelector((state) => state.application);
  const { ctn, incomingInvite } = incomingInvitation;
  const { title, buttonText, imageUrl } = incomingInvite[status];

  const maskedCellNumber = maskPhoneNumber(ctn);
  const currentTitle = templateParser(title, { NUMBER: maskedCellNumber });

  const handleConfirmClick = useCallback(() => {
    dispatch(toggleIncomingInviteModal(false));
    window.location.reload();
  }, []);

  return (
    <RequestStatus
      img={{
        src: imageUrl,
      }}
      title={currentTitle}
      button={{
        text: buttonText,
        variant: 'secondary',
      }}
      onConfirm={handleConfirmClick}
    />
  );
};

InvitationStatus.propTypes = {
  status: PropTypes.string,
};

export { InvitationStatus };
